import { ShareLessonTabs, TabConfig } from './ShareLessonModal.types';

// Tab content mapping
export const tabConfigs: Record<ShareLessonTabs, TabConfig> = {
  [ShareLessonTabs.SHARE_LINK]: {
    id: ShareLessonTabs.SHARE_LINK,
    tabLabelKey: 'shareLessonModal.tab.shareLink',
    imageAssetPath: 'img/shareLessonModal/file-type-slide.svg',
    titleKey: 'shareLessonModal.title.shareLink',
    bodyTextKey: 'shareLessonModal.bodyText.shareLink',
  },
  [ShareLessonTabs.SHARE_WITH_STUDENTS]: {
    id: ShareLessonTabs.SHARE_WITH_STUDENTS,
    tabLabelKey: 'shareLessonModal.tab.shareWithStudents',
    imageAssetPath: 'img/shareLessonModal/file-type-slide.svg',
    titleKey: 'shareLessonModal.title.shareWithStudents',
    bodyTextKey: 'shareLessonModal.bodyText.shareWithStudents',
    banner: 'shareLessonModal.banner.sharedWithStudents',
  },
  [ShareLessonTabs.EXPORT_PDF]: {
    id: ShareLessonTabs.EXPORT_PDF,
    tabLabelKey: 'shareLessonModal.tab.exportPdf',
    imageAssetPath: 'img/shareLessonModal/file-type-pdf.svg',
    titleKey: 'shareLessonModal.title.exportPdf',
    bodyTextKey: 'shareLessonModal.bodyText.exportPdf',
    linkTextKey: 'shareLessonModal.linkText.exportPdf',
    linkUrlKey: 'shareLessonModal.linkUrl.exportPdf',
  },
};
